import { render, staticRenderFns } from "./ServicePackageView.vue?vue&type=template&id=20b35157&scoped=true"
import script from "./ServicePackageView.vue?vue&type=script&lang=js"
export * from "./ServicePackageView.vue?vue&type=script&lang=js"
import style0 from "./ServicePackageView.vue?vue&type=style&index=0&id=20b35157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b35157",
  null
  
)

export default component.exports